export const LeftRightArrowIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 7.90625L3.75 7.90625M6.9 5.65625L9 7.90625L6.9 5.65625ZM9 7.90625L6.9 10.1562L9 7.90625Z"
        stroke="#15112D"
        strokeWidth="0.375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 4.09399L8.25 4.09399M5.1 1.84399L3 4.09399L5.1 1.84399ZM3 4.09399L5.1 6.34399L3 4.09399Z"
        stroke="#15112D"
        strokeWidth="0.375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
